import { create } from 'zustand';

import type { SparksSocialProfileSnapshot } from '@/components/composite/SparksAgent/types';

/**
 * Screen-derived hints for Sparks AI context. Populated when the user is on a view that can
 * publish them (e.g. custom dashboard); cleared on leave so Sparks falls back to defaults.
 */
export type SparksAgentContextStoreState = {
    /**
     * Widget field ids for Sparks `analytics` context. If `null` or `[]`, no `analytics` context item is sent.
     * Otherwise — ids from `useFormatDashboardAnalyticsWidgetsParams` / visible dashboard widgets.
     */
    analyticsFields: string[] | null;
    setAnalyticsFields: (fields: string[] | null) => void;

    /**
     * Profiles attached to the **current custom dashboard** (`/dashboard/view/...`), for Sparks `model` context.
     * Set only while that view is mounted; cleared on leave.
     */
    contextSocialProfiles: SparksSocialProfileSnapshot[] | null;
    setContextSocialProfiles: (profiles: SparksSocialProfileSnapshot[] | null) => void;
};

export const useSparksAgentContextStore = create<SparksAgentContextStoreState>((set) => ({
    analyticsFields: null,
    setAnalyticsFields: (fields) => set({ analyticsFields: fields }),
    contextSocialProfiles: null,
    setContextSocialProfiles: (profiles) => set({ contextSocialProfiles: profiles })
}));
